module.exports = __webpack_public_path__ + "static/pop_btn.e2ca37a5.png";